export const contrType = [
  {
    id: 1,
    name: "신규계약",
  },
  {
    id: 2,
    name: "변경계약",
  },
  {
    id: 3,
    name: "추가계약",
  },
];
